import { Pipe, PipeTransform } from "@angular/core";
import { UntypedFormControl, FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from "@angular/platform-browser";
import { setValidatorsV3 } from "../functions/functions";
import { cloneArray, jsonParse } from "../functions/shared-functions";


@Pipe({
  name: "MasterTitlePipe"
})
export class MasterTitlePipe implements PipeTransform {
  transform(code, masters, id_property, title_property) {
    let out_str;
    id_property = id_property ? id_property : 'code';
    title_property = title_property ? title_property : 'title';

    if (code && masters && masters.length) {
      for (let i = 0; i < masters.length; i++) {
        if (masters[i][id_property] == code) {
          out_str = masters[i][title_property];
          break;
        }

      }
    }

    return out_str || ''
  }
}
export class TalliteErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent && control.parent.dirty);
    const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);

    return (invalidCtrl || invalidParent);
  }
}


@Pipe({
  name: 'DynamicFormFieldProcessingPipe'
})
export class DynamicFormFieldProcessingPipe implements PipeTransform {
  transform(value, form_group, parent_form, section, field, field_Ref, all_form, all_form_ref,masters): any {
    let out_status = true;
    if (field && field.UIValidationObjStruct) {

      if (field.UIValidationObjStruct.mandatory && field.UIValidationObjStruct.mandatory.condition) {
        try {
          field.UIValidationObjStruct.mandatory.value = eval(field.UIValidationObjStruct.mandatory.condition);
        }
        catch (err) {

        }
        setValidatorsV3(section.multiple ? section.multiple_form : form_group, field);
      }
      else {

      }
      if (field.UIValidationObjStruct.disabled && field.UIValidationObjStruct.disabled.condition) {
        try {
          field.UIValidationObjStruct.disabled.value = eval(field.UIValidationObjStruct.disabled.condition);
        }
        catch (err) {

        }
        setValidatorsV3(section.multiple ? section.multiple_form : form_group, field);
      }
      else {

      }

      if (field.UIValidationObjStruct.hide && field.UIValidationObjStruct.hide.condition) {
        try {
          field.UIValidationObjStruct.hide.value = eval(field.UIValidationObjStruct.hide.condition);
        }
        catch (err) {

        }
        setValidatorsV3(section.multiple ? section.multiple_form : form_group, field);
      }
      else {

      }

      if (field.UIValidationObjStruct.evaluate && field.UIValidationObjStruct.evaluate.condition) {
        try {
          eval(field.UIValidationObjStruct.evaluate.condition)
        }
        catch (err) { }
      }


    }
    else {
      return out_status;
    }
    return out_status;
  }
}




@Pipe({
  name: 'DynamicFormSectionProcessingPipe'
})
export class DynamicFormSectionProcessingPipe implements PipeTransform {
  transform(parent_form, section, form_group, all_form): any {
    let out_status = true;
    if (section && section.validators) {
      if (section.validators.min_length_validation && section.validators.min_length_validation.condition) {
        try {
          section.validators.min_length = eval(section.validators.min_length_validation.condition);
        }
        catch (err) {

        }
        // setValidatorsV3(form_group, field);
      }

      if (section.validators.max_length_validation && section.validators.max_length_validation.condition) {
        try {
          section.validators.max_length = eval(section.validators.max_length_validation.condition);
        }
        catch (err) {

        }
        // setValidatorsV3(form_group, field);
      }
      if (section.validators.hide && section.validators.hide.condition) {
        try {
          section.validators.hide.value = eval(section.validators.hide.condition);
        }
        catch (err) {

        }
        // setValidatorsV3(form_group, field);
      }
      else {

      }

      if (section.validators && section.validators.hide) {
        if (section.validators.hide.value) {
          form_group.disable();
        }
        else {
          form_group.enable();
        }
      }
    }
    else {
      return out_status;
    }
    return out_status;
  }
}






@Pipe({
  name: 'safeHTMLPipe'
})
export class safeHTMLPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
      case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
      case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
      case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      default: throw new Error(`Invalid safe type specified: ${type}`);
    }
  }
}

@Pipe({
  name: 'cloneArrayPipe'
})

export class cloneArrayPipe implements PipeTransform {
  transform(value): any {
    return cloneArray(value)
  }
}

@Pipe({
  name: 'checkTemplate'
})
export class checkTemplateCondition implements PipeTransform {
  transform(style: any, data_row: any, column, isHeader?): any {
    if (style && style.displayRefColumnName == column.property) {
      if (style && style.list && style.list.length) {
        let currentStyle;
        for (let i = 0; i < style.list.length; i++) {
          let item = style.list[i];

          if (item.cellTemplate) {
            item.cellTemplate = jsonParse(item.cellTemplate)
            if (item.condition && item.condition != '') {
              try {
                if (eval(item.condition)) {
                  return item.cellTemplate;
                }
              }
              catch (err) {
                console.log('Due to dynamic condition false, please check' + err)
              }

            }
            else {
              return item.cellTemplate
            }
          }

        }
      }
    }
    // var date1 = new Date(data_row.postedOn);
    // var date2 = new Date();

    // var Difference_In_Time = date2.getTime() - date1.getTime();

    // var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24)) ;
    // console.log(Difference_In_Days);
    // if(Difference_In_Days > 3 && data_row.totalResCount==0){
    //   1;
    // }
    // else{
    //   0;
    // }


  }
}

@Pipe({
  name: 'checkStyle'
})
export class checkStyleCondition implements PipeTransform {
  transform(style: any, data_row: any, column, isHeader?): any {
    if (style && style.list && style.list.length) {
      let currentStyle;
      for (let i = 0; i < style.list.length; i++) {
        let item = style.list[i];
        if (isHeader && item.applyForHeader) {
          if (item.rowOrCell == 1) {
            return {
              'background-color': item.bgTrans ? 'transparent' : item.bgColor,
              'color': item.fontColor,
              'font-weight': item.fontWeight,
              'font-style': item.fontStyle,
            };
          }
          else if (item.rowOrCell == 2) {
            if (column['property'] == style.displayRefColumnName) {
              return {
                'background-color': item.bgTrans ? 'transparent' : item.bgColor,
                'color': item.fontColor,
                'font-weight': item.fontWeight,
                'font-style': item.fontStyle,
              };
            }
          }
        }
        else if (!isHeader && !item.applyForHeader) {
          if (item.condition && item.condition != '') {
            try {
              if (eval(item.condition)) {
                if (item.rowOrCell == 1) {
                  return {
                    'background-color': item.bgTrans ? 'transparent' : item.bgColor,
                    'color': item.fontColor,
                    'font-weight': item.fontWeight,
                    'font-style': item.fontStyle,
                  };
                }
                else if (item.rowOrCell == 2) {
                  if (column['property'] == style.displayRefColumnName) {
                    return {
                      'background-color': item.bgTrans ? 'transparent' : item.bgColor,
                      'color': item.fontColor,
                      'font-weight': item.fontWeight,
                      'font-style': item.fontStyle,
                    };
                  }
                }
              }
            }
            catch (err) {
              console.log('Due to dynamic condition false, please check' + err)
            }

          }
          else if (item.code == data_row[style.compareRefColumnName] && data_row[style.compareRefColumnName]) {
            if (item.rowOrCell == 1) {
              return {
                'background-color': item.bgTrans ? 'transparent' : item.bgColor,
                'color': item.fontColor,
                'font-weight': item.fontWeight,
                'font-style': item.fontStyle,
              };
            }
            else if (item.rowOrCell == 2) {
              if (column['property'] == style.displayRefColumnName) {
                return {
                  'background-color': item.bgTrans ? 'transparent' : item.bgColor,
                  'color': item.fontColor,
                  'font-weight': item.fontWeight,
                  'font-style': item.fontStyle,
                };
              }
            }
          }
          else {
            if (item.rowOrCell == 1) {
              return {
                'background-color': item.bgTrans ? 'transparent' : item.bgColor,
                'color': item.fontColor,
                'font-weight': item.fontWeight,
                'font-style': item.fontStyle,
              };
            }
            else if (item.rowOrCell == 2) {
              if (column['property'] == style.displayRefColumnName) {
                return {
                  'background-color': item.bgTrans ? 'transparent' : item.bgColor,
                  'color': item.fontColor,
                  'font-weight': item.fontWeight,
                  'font-style': item.fontStyle,
                };
              }
            }
          }
        }
      }
    }
  }
}



@Pipe({
  name: 'TMsafeHTML'
})
export class TMsafeHTMLPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
      case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
      case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
      case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      default: throw new Error(`Invalid safe type specified: ${type}`);
    }
  }
}

@Pipe({
  name: 'HTMLFormatterDecode'
})
export class HTMLFormatterDecode implements PipeTransform {
  transform(input, flag?) {
    if (input) {
      try {
        let a = decodeURIComponent(input)
        input = a;
      }
      catch (err) {

        input = input;
      }
      let out_str = (' ' + input).slice(1);
      try {
        out_str = out_str.replace(/&nbsp;/g, ' ');
        out_str = out_str.replace(/nbsp;/g, ' ');
        out_str = out_str.replace(/&amp;/g, '');
        out_str = out_str.replace(/amp;/g, '');
        out_str = out_str.replace(/amp;/g, '');
        out_str = out_str.replace(/(?:\r\n|\r|\n)/g, '<br>');
        out_str = out_str.replace(/\\n/g, '<br/>');

        if (flag) {
          out_str = out_str.replace(/\<[a-z]{1,6}\>/g, '');
          out_str = out_str.replace(/<\/[a-z]{1,6}>/g, '');
        }
      }
      catch (err) {
        out_str = input;
      }
      return out_str;
    }
  }
}
